<template>
    

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll" >

        <!-- SIDEBAR -->
        <SidebarBody />

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody />


            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content">

                <div class="row mb-32 gy-16 dash-top" style="padding-bottom: 500px;">

                    <!-- BANNER -->
                    <div class="col-12 " style="margin-top: -10px;">

                        <!-- MAIN BALANCE -->
                        <div class="hp-bg-black-b   position-relative overflow-hidden hp-page-content pBack1" style="border-radius: 20px; background-size: cover; " >

                            <div class="row">
                                
                                <div class="col-sm-12">

                                    <div class="car" >
                                        <div class="card-body ">

                                            <div class="row">

                                                <div class="col-12">

                                                    <div class="mm-none">

                                                        <div  style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 0px 50px; margin-bottom: 20px;">
                                                        

                                                        <div>
                                                            <p class="hp-p1-body mb-0 text-black-60 hp-text-color-dark-30">Total Earnings</p>
                                                            <h1 class="mb-4 mt-8" style="font-size: 50px; color: #fff;"> <span>&#8358;</span>  {{ refBalanceD }} </h1>

                                                        </div>

                                                        <div >
                                                            <button @click="withdrawClick" class="btn btn-primary " style=" color: #fff;  margin-right: 20px; margin-top: 50px; margin-bottom: 20px; ">

                                                                <i class="hp-text-color-dark-0 iconly-Light-ArrowUpSquare" ></i>
                                                                <span style="padding-left: 10px;">Withdraw</span>

                                                            </button>
                                                        </div>

                                                        

                                                    </div>

                                                    </div>

                                                    <div class="dd-none" style=" justify-content: space-between; align-items: center; width: 100%; padding: 0px 10px; margin-bottom: 20px;">
                                                        

                                                        <div>
                                                            <p class="hp-p1-body mb-0 text-black-60 hp-text-color-dark-30 mt-24">Total Earnings</p>
                                                            <h1 class="mb-4 mt-16" style="font-size: 36px; color: #fff;"> <span>&#8358;</span>  {{ refBalanceD }} </h1>
                                                            

                                                            

                                                        </div>

                                                        <div >
                                                            <button @click="withdrawClick" class="btn btn-primary " style=" color: #fff;  margin-right: 20px; margin-top: 50px; margin-bottom: 10px; background-color: #fff; ">

                                                                <i class="hp-text-color-dark-0 iconly-Light-ArrowUpSquare" ></i>
                                                                <span style="padding-left: 10px;">Withdraw</span>

                                                            </button>
                                                        </div>

                                                        

                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    
                                </div>

                            </div>
                            
                        </div>

                    </div>

                    <!-- INFO -->
                    <div class="col-12 col-xl-6" >

                        <div class="card hp-card-6">

                            <div class="card-body">

                                <div class="row" style="padding: 20px;">

                                    <h4>Referral link</h4>
                                    <p class="hp-p1-body">Share your referral link via social media and earn a {{ refCut }}% commission </p>

                                    <div class="input-group  mt-18" >
                                        <input type="text" class="form-control" aria-label="Recipient's username" aria-describedby="button-addon2" disabled=""  v-model="refLink">
                                        
                                        <button class="btn btn-icon-only btn-primary" @click="copyRef">
                                            <i class="hp-text-color-dark-0 ri-file-copy-line"></i>
                                        </button>
                                    </div>

                                    <div class="divider mt-32 mb-32"></div>

                                    <h4>Invite your friends</h4>
                                    <p class="hp-p1-body">Invite your friends to join Baesnap via email</p>

                                    <div style="position: relative; margin-bottom: 80px; padding-bottom: 10px;">

                                        <form @submit.prevent="refInvite">

                                            <div class="input-group  mt-18" >
                                                <input type="email" class="form-control" aria-label="email" aria-describedby="button-addon2" v-model="refEmail" required placeholder="Email...">
                                                
                                                <button class="btn btn-icon-only btn-primary">
                                                    <i class="hp-text-color-dark-0 iconly-Light-Send" style="font-size: 16px;"></i>
                                                </button>
                                            </div>

                                        </form>

                                        <div class="d-none" style="width: 100%; display: flex; justify-content: center; align-items: center; margin-top: 10px;">

                                            <i class="hp-text-color-dark-0 iconly-Light-Message" style="font-size: 22px; margin-right: -40px; color: #b2bec3;"></i>

                                            <input type="text" class="form-control" placeholder="email..." aria-label="email" aria-describedby="button-addon2" style="border-radius: 23px; background-color: transparent; padding-left: 50px; padding-right: 50px; padding-top: 5px; padding-bottom: 5px; ">

                                            <button class="btn btn-icon-only rounded-circle btn-primary" style="position: absolute; right: 30px;  ">
                                                <i class="hp-text-color-dark-0 iconly-Light-Send" style="font-size: 16px;"></i>
                                            </button>

                                            
                                        
                                        </div>

                                    </div>

                                    <br><br>

                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- INFO2 -->
                    <div class="col-12 col-xl-6 mm-none" >

                        <div class="card hp-card-6">

                            <div class="card-body">

                                <div class="row" style="padding: 20px;">

                                    <h4>Referrals </h4>
                                    <p class="hp-p1-body">Invite your audience, friends and family to Baesnap. <br> Earn up to {{refCut}}% in commissions.</p>

                                    <div class="divider mt-18 mb-18"></div>

                                    <ul class="timeline hp-p2-body" style="margin-top: 10px;">
                                        <li class="timeline-item">
                                            <div class="timeline-item-tail"></div>
                                            <div class="timeline-item-head"></div>
                                            <div class="timeline-item-content">
                                                <h6>Send Invitation</h6>
                                                <p class="hp-p1-body" style="margin-top: -10px;"> Share your referral link anywhere you like. The more you share, the more you earn. </p>
                                            </div>
                                        </li>

                                        <li class="timeline-item">
                                            <div class="timeline-item-tail"></div>
                                            <div class="timeline-item-head"></div>
                                            <div class="timeline-item-content">
                                                <h6>Registration</h6>
                                                <p class="hp-p1-body" style="margin-top: -10px;"> When someone signs up using your link, They are automatically linked to your account </p>
                                            </div>
                                        </li>

                                        <li class="timeline-item">
                                            <div class="timeline-item-tail"></div>
                                            <div class="timeline-item-head"></div>
                                            <div class="timeline-item-content">
                                                <h6>Get Commission</h6>
                                                <p class="hp-p1-body" style="margin-top: -10px;"> You earn up to {{ refCut }}% of the earnings from every creator you refer. </p>
                                            </div>
                                        </li>
                                            
                                    </ul>
                                    

                                </div>

                            </div>

                        </div>

                    </div>

                    <div class="col-12 mt-42">

                        <div class="row g-32">

                            <div class="col-12 ">

                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link active" id="referral-tab" data-bs-toggle="tab"
                                            data-bs-target="#referral" role="tab" aria-controls="referral"
                                            aria-selected="true" style="cursor: pointer;"> Referrals  </h6>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="deposit-tab" data-bs-toggle="tab"
                                            data-bs-target="#deposit" role="tab" aria-controls="deposit"
                                            aria-selected="false" style="cursor: pointer;"> Deposits </h6>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="withdrawal-tab" data-bs-toggle="tab"
                                            data-bs-target="#withdrawal" role="tab" aria-controls="withdrawal"
                                            aria-selected="false" style="cursor: pointer;"> Withdrawals </h6>
                                    </li>

                                </ul>

                                <!-- TAB CONTENT -->
                                <div class="tab-content">

                                    <!-- REFS -->
                                    <div class="tab-pane fade show active" id="referral" role="tabpanel"
                                        aria-labelledby="deposit-tab">

                                        <!-- DUPLI -->
                                        <div v-for="(ref, index) in refList" :key="'number'+index" class="card hp-project-ecommerce-table-card"
                                            style="margin-bottom: 10px; border-radius: 10px;">
                                            <div class="card-body ">

                                                <div class="row" >

                                                    <div class="col-12">

                                                        <div class="row g-32 ">

                                                            <div class="col-12 col-sm-4 ">

                                                                <div class="row gx-8 gy-16">

                                                                    <div class="row align-items-center" @click="profileClick(ref.userId, ref.userName)" >
                                                                        <div class="w-auto px-0"
                                                                            
                                                                            style="cursor: pointer;">
                                                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                style="width: 58px; height: 58px; ">
                                                                                <img :src="ref.profilePic" class="hp-img-cover"
                                                                                    style="width: 58px; height: 58px; background-color: black; object-fit: cover; border-color: #b2bec3; border-width: 1px; border-style: solid; ">
                                                                            </div>
                                                                        </div>

                                                                        <div class="w-auto ms-8 px-0 mt-12">
                                                                            <span
                                                                                class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">
                                                                                
                                                                                <span > {{ ref.fullName }} </span>

                                                                                <span v-if="ref.userType == 'model'">
                                                                                    <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;" > 
                                                                                </span> 

                                                                                <span v-if="ref.sexuality == 'gay'">
                                                                                    <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                                </span>

                                                                                <span v-else-if="ref.sexuality == 'lesibian'">
                                                                                    <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                                </span>

                                                                                <span v-else-if="ref.sexuality == 'bisexual'">
                                                                                    <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                                </span>
                                                                                
                                                                            </span>
                                                                            <p
                                                                                class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                                @{{ ref.userName }}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div class="col-6 col-sm-3">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> <span>&#8358;</span> {{ ref.refBalanceD }} </strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Total commission
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            
                                                            <div class="col-6 col-sm-3">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">

                                                                        <!-- <strong class="mb-4 dd-none">{{
                                                                            tran.dateD}}</strong>
                                                                        <strong class="mb-4 mm-none">{{
                                                                            tran.dateFull}}</strong> -->

                                                                            <strong>{{ ref.dateFull }}</strong>

                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Date joined
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong v-if="ref.status == 'active'" 
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-12 px-24 fw-medium ">
                                                                            Active </strong>

                                                                        <strong v-else
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-12 px-24 fw-medium ">
                                                                            Expired </strong>

                                                                        


                                                                    </div>


                                                                </div>
                                                            </div>

                                                            


                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div id="emptyRef2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite" class="spinner">

                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex ; visibility: hidden;  justify-content: center; align-items: center; flex-direction: column; width: 100%;" id="emptyRef">
                                            <p class="hp-badge-text">No referrals yet...</p>
                                        </div>



                                    </div>

                                    <!-- DEPOSIT -->
                                    <div class="tab-pane fade" id="deposit" role="tabpanel"
                                        aria-labelledby="deposit-tab">

                                        <!-- DUPLI -->
                                        <div class="card hp-project-ecommerce-table-card" v-for="(ref, index) in depositList" :key="'number'+index"
                                            style="margin-bottom: 10px; border-radius: 10px;">
                                            <div class="card-body ">

                                                <div class="row" >

                                                    <div class="col-12">

                                                        <div class="row g-32 ">

                                                            <div class="col-12 col-sm-4 ">

                                                                <div class="row gx-8 gy-16">

                                                                    <div class="row align-items-center" >
                                                                        <div class="w-auto px-0"
                                                                            
                                                                            style="cursor: pointer;">
                                                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                                                                                style="width: 58px; height: 58px; ">
                                                                                <img :src="ref.profilePic" class="hp-img-cover"
                                                                                    style="width: 58px; height: 58px; background-color: black; object-fit: cover; border-color: #b2bec3; border-width: 1px; border-style: solid; ">
                                                                            </div>
                                                                        </div>

                                                                        <div class="w-auto ms-8 px-0 mt-12">
                                                                            <span
                                                                                class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">
                                                                                
                                                                                <span >{{ ref.fullName }}</span>

                                                                                <span v-if="ref.userType == 'model'" >
                                                                                    <img src="@/assets/img/check-circle.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;" > 
                                                                                </span> 

                                                                                <span v-if="ref.sexuality == 'gay'">
                                                                                    <img src="@/assets/img/gay.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                                </span>

                                                                                <span v-else-if="ref.sexuality == 'lesibian'">
                                                                                    <img src="@/assets/img/lesibian.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                                </span>

                                                                                <span v-else-if="ref.sexuality == 'bisexual'">
                                                                                    <img src="@/assets/img/bisexual.png" alt="" style="width: 13px; height: 13px; margin-left: 5px; margin-top: -3px;">
                                                                                </span>
                                                                                
                                                                            </span>
                                                                            <p
                                                                                class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">
                                                                                @{{ ref.userName }}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div class="col-6 col-sm-3">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> <span>&#8358;</span> {{ ref.refAmountD }} </strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Commission
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-3">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">

                                                                        <!-- <strong class="mb-4 dd-none">{{
                                                                            tran.dateD}}</strong>
                                                                        <strong class="mb-4 mm-none">{{
                                                                            tran.dateFull}}</strong> -->

                                                                            <strong>{{ ref.dateFull }}</strong>

                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Date joined
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                            </div>



                                                            <div class="col-6 col-sm-2">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong 
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-12 px-24 fw-medium ">
                                                                            {{ ref.status }} </strong>

                                                                    </div>


                                                                </div>
                                                            </div>

                                                            


                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div id="emptyDeposit2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite2" class="spinner">
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex ; visibility: hidden;  justify-content: center; align-items: center; flex-direction: column; width: 100%;" id="emptyDeposit">
                                            <p class="hp-badge-text">No deposits yet...</p>
                                        </div>



                                    </div>

                                    <!-- WITHDRAW -->
                                    <div class="tab-pane fade" id="withdrawal" role="tabpanel"
                                        aria-labelledby="deposit-tab">

                                        <!-- DUPLI -->
                                        <div class="card hp-project-ecommerce-table-card" v-for="(ref, index) in withdrawList" :key="'number'+index"
                                            style="margin-bottom: 10px; border-radius: 10px;">
                                            <div class="card-body ">

                                                <div class="row" >

                                                    <div class="col-12">

                                                        <div class="row g-32 ">

                                                            <div class="col-12 col-sm-4 ">

                                                                <div class="row gx-8 gy-16">

                                                                    <div class="row align-items-center" v-if="ref.type2 == 'bank'" >
                                                                        <div class="w-auto px-0"
                                                                            
                                                                            style="cursor: pointer;">
                                                                            <div class="avatar-ite d-flex align-items-center justify-content-center "
                                                                                style="width: 58px; height: 58px; ">
                                                                                <img :src="ref.profilePic" class="hp-img-cover"
                                                                                    style="width: 58px; height: 58px; object-fit: cover;  ">
                                                                            </div>
                                                                        </div>

                                                                        <div class="w-auto ms-8 px-0 mt-12">
                                                                            <span
                                                                                class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">
                                                                                
                                                                                <span >{{ ref.accountName }}</span>

                                                                                
                                                                                
                                                                            </span>
                                                                            <p
                                                                                class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4" style="word-break: break-all; width: 220px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; " >
                                                                                {{ ref.accountNumber }}</p>
                                                                        </div>
                                                                    </div>

                                                                    <div class="row align-items-center" v-else >
                                                                        <div class="w-auto px-0"
                                                                            
                                                                            style="cursor: pointer;">
                                                                            <div class="avatar-ite d-flex align-items-center justify-content-center rounded-circl"
                                                                                style="width: 58px; height: 58px; ">
                                                                                <img :src="ref.profilePic" class="hp-img-cover"
                                                                                    style="width: 58px; height: 58px; object-fit: cover; ">
                                                                            </div>
                                                                        </div>

                                                                        <div class="w-auto ms-8 px-0 mt-12">
                                                                            <span
                                                                                class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM">
                                                                                
                                                                                <span >{{ ref.accountName }}</span>

                                                                                
                                                                                
                                                                            </span>
                                                                            <p
                                                                                class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4" style="word-break: break-all; width: 220px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; ">
                                                                                {{ ref.accountNumber }}</p>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div class="col-6 col-sm-2">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> <span>&#8358;</span> {{ ref.payoutAmountD }} </strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Amount
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong class="mb-4"> <span>&#8358;</span> {{ ref.serviceChargeD }} </strong>
                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Service charge
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2">
                                                                <div class="row gx-8 gy-16">

                                                                    <div class="col hp-flex-none w-auto">

                                                                        <!-- <strong class="mb-4 dd-none">{{
                                                                            tran.dateD}}</strong>
                                                                        <strong class="mb-4 mm-none">{{
                                                                            tran.dateFull}}</strong> -->

                                                                            <strong>{{ ref.dateFull }}</strong>

                                                                        <p
                                                                            class="hp-badge-text mb-0 text-black-50 hp-text-color-dark-30">
                                                                            Date
                                                                        </p>
                                                                    </div>


                                                                </div>
                                                            </div>

                                                            <div class="col-6 col-sm-2">
                                                                <div class="row gx-8 gy-16">


                                                                    <div class="col hp-flex-none w-auto">
                                                                        <strong v-if="ref.status == 'completed'" 
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-success-4 hp-bg-dark-success text-success border-none w-auto py-12 px-24 fw-medium ">
                                                                            Successful </strong>

                                                                        <strong v-else-if="ref.status == 'pending'" 
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-warning-4 hp-bg-dark-warning text-warning border-none w-auto py-12 px-24 fw-medium ">
                                                                            Pending </strong>

                                                                        <strong v-else
                                                                            style="font-size: 14px;"
                                                                            class="badge bg-danger-4 hp-bg-dark-danger text-danger border-none w-auto py-12 px-24 fw-medium ">
                                                                            Failed </strong>

                                                                        


                                                                    </div>


                                                                </div>
                                                            </div>




                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>


                                        <div id="emptyWithdraw2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                            <InfiniteLoading @infinite="handleInfinite3" class="spinner">
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex ; visibility: hidden;  justify-content: center; align-items: center; flex-direction: column; width: 100%;" id="emptyWithdraw">
                                            <p class="hp-badge-text">No withdrawals yet...</p>
                                        </div>


                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>

                    

                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px"
                width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z">
                    </path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ loadingText }} </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- COPY TOAST -->
    <div class="position-fixed bottom-0 end-0 p-16" style="z-index: 99">
        <div data-id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true" id="toastDiv" style="background-color: #e8def7; padding: 10px;">
            <div class="toast-header" style="background-color: #e8def7;">
                
                <strong class="me-auto">Baesnap</strong>
                <small>1 second ago</small>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>

            <div class="toast-body">
                {{toastMessage}}
            </div>
        </div>
    </div>

    <!-- WITHDRAW -->
    <div class="modal fade" id="withdraw" tabindex="-1" aria-labelledby="withdrawLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title">Withdraw</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body" style="margin-top: -20px;">

                    <ul class="nav nav-tabs mb-12" id="myTab" role="tablist" style="width: 100%;">
                        <li class="nav-item" role="presentation" style="width: 50%;">
                            <h6 class="nav-link active" id="bank-tab" data-bs-toggle="tab" data-bs-target="#bank" role="tab" aria-controls="bank" aria-selected="true" style="cursor: pointer;"> Bank  </h6>
                        </li>
                        
                        <li class="nav-item" role="presentation" style="width: 50%;">
                            <h6 class="nav-link" id="crypto-tab" data-bs-toggle="tab" data-bs-target="#crypto" role="tab" aria-controls="crypto" aria-selected="false" style="cursor: pointer;"> Crypto </h6>
                        </li>

                    </ul>

                    <div class="tab-content" >

                        <!-- BANK -->
                        <div class="tab-pane fade show active" id="bank" role="tabpanel" aria-labelledby="bank-tab">
                            
                            <form @submit.prevent="withdraw">

                                <div class="mb-24" style="margin-top: 30px;">

                                    <label for="displayName" class="form-label">Amount</label>
                                    <div class="input-group mb-16">
                                        <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                        <input type="number" class="form-control" placeholder="0.00" aria-label="Username"
                                            aria-describedby="basic-addon1" :value="withdrawAmount" disabled>

                                    </div>
                                    <p class="hp-p2-body" style="margin-top: -10px; font-size: 12px;">Kindly note that a service
                                        charge of <strong>&#8358;{{ serviceCharge }}</strong> will be used to process this
                                        transaction </p>

                                </div>

                                <div class="mb-24" style="position: relative; margin-top: 30px;">

                                    <label class="form-label">Bank name</label>

                                    <div class="col-12 col-lg-12" @click="bankOpen">
                                        <div class="hp-select-box-item" >
                                            <input type="radio" hidden="" id="select-box-logo-item-9" name="select-box-item-9" >
                                            <label for="select-box-logo-item-3" class="d-block hp-cursor-pointer">
                                                <div class="card" style="border-radius: 10px !important; border-color: #b2bec3;">
                                                    <div class="card-body" style="padding: 6px;">
                                                        <div class="row justify-content-between ">
                                                            <div class="col-12 ">
                                                                <div class="d-flex justify-content-start align-items-center"
                                                                    style="align-items: center;">
                                                                    <img :src="bankImage" alt=""
                                                                        style="width: 30px; height: 30px; margin-right: 10px; margin-left: 5px;">
                                                                    <span class="hp-p1-body"> {{ bankName }} </span>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>


                                </div>

                                <div class="mb-24">
                                    <label for="exampleInputEmail1" class="form-label">Account name</label>
                                    <input type="text" class="form-control" aria-describedby="emailHelp"
                                        placeholder="e.g John Mark Smith" v-model="accountName" required>

                                </div>

                                <div class="mb-24">
                                    <label for="exampleInputEmail1" class="form-label">Account number</label>
                                    <input type="number" class="form-control" aria-describedby="emailHelp"
                                        placeholder="e.g 6320655784" v-model="accountNumber" required>

                                </div>


                                <div class="divider mt-18 mb-16"></div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                                    <button type="submit" class="btn btn-primary">Proceed</button>
                                </div>

                            </form>

                        </div>

                        <!-- CRYPTO -->
                        <div class="tab-pane fade" id="crypto" role="tabpanel" aria-labelledby="crypto-tab">
                            
                            <form @submit.prevent="cryptoWithdraw">

                                <div class="mb-24" style="margin-top: 30px;">

                                    <label for="displayName" class="form-label">Amount</label>
                                    <div class="input-group mb-16">
                                        <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                        <input type="number" class="form-control" placeholder="0.00" aria-label="Username"
                                            aria-describedby="basic-addon1" :value="withdrawAmount" disabled>

                                    </div>
                                    <p class="hp-p2-body" style="margin-top: -10px; font-size: 12px;">Kindly note that a service
                                        charge of <strong>&#8358;{{ serviceCharge }}</strong> will be used to process this
                                        transaction </p>

                                </div>

                                <div class="mb-24" style="position: relative; margin-top: 30px;">

                                    <label class="form-label">Coin name</label>

                                    <div class="col-12 col-lg-12" @click="coinOpen">
                                        <div class="hp-select-box-item" >
                                            <input type="radio" hidden="" id="select-box-logo-item-9" name="select-box-item-9" >
                                            <label for="select-box-logo-item-3" class="d-block hp-cursor-pointer">
                                                <div class="card" style="border-radius: 10px !important; border-color: #b2bec3;">
                                                    <div class="card-body" style="padding: 6px;">
                                                        <div class="row justify-content-between ">
                                                            <div class="col-12 ">
                                                                <div class="d-flex justify-content-start align-items-center"
                                                                    style="align-items: center;">
                                                                    <img :src="coinImage" alt=""
                                                                        style="width: 30px; height: 30px; margin-right: 10px; margin-left: 5px;" id="coinImage">
                                                                    <span class="hp-p1-body"> {{ coinName }} </span>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>


                                </div>

                                

                                <div class="mb-24">
                                    <label for="exampleInputEmail1" class="form-label">Wallet Address</label>
                                    <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="e.g 0x27A75b4e4425313eEAb0685AbA66Fe4557e79c10"
                                        v-model="coinAddress" required>

                                </div>


                                <div class="divider mt-18 mb-16"></div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                                    <button type="submit" class="btn btn-primary">Proceed</button>
                                </div>

                            </form>


                        </div>


                    </div>

                </div>

            </div>
        </div>
    </div>

    <!-- Bank list -->
    <div class="modal fade" id="bankModal" tabindex="-1" aria-labelledby="bankModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm" >

            <div class="modal-content" style="border-color: #000; border-width: 2px; border-style: dashed;">
                <div class="modal-header py-16" style="margin-top: 10px;">
                    <h5 class="modal-title" id="createModalLabel" style="text-align: center; width: 100%;">Select bank</h5>
                    <button type="button"
                        class="btn-close hp-bg-none d-flex align-items-center justify-content-center"
                        data-bs-dismiss="modal" aria-label="Close" >
                        <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                    </button>
                </div>
                <div class="col-12" style="padding-left: 20px; padding-right: 20px;">
                    <input type="text" class="form-control" placeholder="Search..." style="margin-bottom: 20px; ">
                </div>

                <div class="divider my-0"></div>

                <div class="modal-body py-18">

                    <div class="row" data-bs-dismiss="modal" style="cursor: pointer;" v-for="bank in bankList" :key="bank.code" @click="bankSelect(bank)">
                        <div class="col-4">
                            <img :src="bank.logo" alt="" style="width: 30px; height: 30px; ">
                        </div>
                        <div class="col-8">
                            <p class="group-text" style="font-size: 14px; text-align: start; margin-left: -50px;"> {{ bank.name }}</p>
                        </div>
                        <div class="col-12">
                            <div class="divider my-4 mb-16"></div>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
    </div>

    <!-- Coin list -->
    <div class="modal fade" id="coinModal" tabindex="-1" aria-labelledby="coinModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm" >

            <div class="modal-content" style="border-color: #000; border-width: 2px; border-style: dashed;">
                <div class="modal-header py-16" style="margin-top: 10px;">
                    <h5 class="modal-title" id="createModalLabel" style="text-align: center; width: 100%;">Select coin</h5>
                    <button type="button"
                        class="btn-close hp-bg-none d-flex align-items-center justify-content-center"
                        data-bs-dismiss="modal" aria-label="Close" >
                        <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                    </button>
                </div>

                <div class="divider my-0"></div>

                <div class="modal-body py-18">

                    <div class="row" data-bs-dismiss="modal" style="cursor: pointer;" v-for="coin in coinList" :key="coin.id" @click="coinSelect(coin)">
                        <div class="col-4">
                            <img :src="coin.image" alt="" style="width: 30px; height: 30px; ">
                        </div>
                        <div class="col-8">
                            <p class="group-text" style="font-size: 14px; text-align: start; margin-left: -50px; margin-top: 3px;"> {{ coin.name }}</p>
                        </div>
                        <div class="col-12">
                            <div class="divider my-4 mb-16"></div>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
    </div>

    <!-- Paassword and pin -->
    <div class="modal fade" id="password" tabindex="-1" aria-labelledby="withdrawLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">

                    <h4 class="modal-title"> Withdrawal Pin </h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body" style="margin-top: -40px;">
                    <p class="hp-p2-body" style="margin-top: -10px; font-size: 12px;">Enter your password along with the
                        Withdrawal pin sent to your email. Remember to check your <strong>SPAM / JUNK</strong> if you do
                        not find the pin in your primary inbox. </p>

                        <div class="divider mt-18 mb-16"></div>

                    <form @submit.prevent="withdraw2">

                        <div class="mb-24">

                            <h1 style="text-align: center; width: 100%;" > &#8358; {{ payoutAmount.toLocaleString("en-US") }}</h1>

                            <div class="d-flex align-items-center justify-content-center psw-pad"
                                style="width: 100%; flex-direction: column;">

                                <div
                                    style="display: flex; justify-content: space-between; width: 100%;align-items: center;">
                                    <p style="text-align: start; width: 100%;" class="hp-badge-text"> Service charge
                                    </p>

                                    <p style="text-align: end; width: 100%; font-weight: 700;"
                                        class="hp-badge-text text-black-80"> &#8358; {{ serviceCharge.toLocaleString("en-US") }}</p>
                                </div>

                            </div>

                        </div>

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Password</label>
                            <input type="password" class="form-control" placeholder="*********" aria-label="Username"
                                aria-describedby="basic-addon1" required v-model="password">

                        </div>

                        <div class="mb-24">
                            <label for="exampleInputEmail1" class="form-label">Pin</label>
                            <VuePincodeInput v-model="pin" :digits="5" success-class="border-2 border-green-400"
                                input-class="" spacing-class="mr-8" autofocus />

                        </div>

                        <div class="divider mt-18 mb-16"></div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>

                    </form>


                </div>




            </div>
        </div>
    </div>

</template>

<style scoped>
.tba {
    display: flex;
    justify-content: start;
    align-items: flex-start;
}

input.vue-pincode-input {
    border: none;
    text-align: center;
    max-width: 70px;
    min-height: 70px;
    font-size: 35px;
    border: 1px solid #b2bec3;
    border-radius: 6px;
    margin-right: 5px;
}

.border-green-400 {
    border-color: #9146ff;
}

.psw-pad {
    padding-left: 100px;
    padding-right: 100px;
}

.fnds{
    z-index: 99;
}

.pBack1{

    background-image: url(../assets/img/pback5.png);
    background-size: contain;
    object-fit: cover;
    background-position: center;
    border-style: none;

    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

}

.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: none;
  border: 1px solid transparent;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
  border-top-width: 0px;
  border-left-width: 0;
  border-right-width: 0px;

  background-color: #f9f7fc;
  isolation: isolate;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: transparent;
  border-bottom-color:  #9146ff;
  border-top-width: 0px;
  border-left-width: 0;
  border-right-width: 0px;

  border-bottom-width: 2px;
}

@media screen and (max-width: 600px) {

    .psw-pad {
        padding-left: 70px;
        padding-right: 70px;
    }

    .tba {
        display: flex;
        justify-content: end;
        align-items: flex-start;
    }

    input.vue-pincode-input {
        border: none;
        text-align: center;
        max-width: 55px;
        min-height: 65px;
        font-size: 40px;
        border: 1px solid #b2bec3;
        border-radius: 6px;
        margin-right: 5px;
    }

    .fnds{
        z-index: 9;
    }
}
</style>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";
    import VuePincodeInput from 'vue3-pincode-input';
    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove, Timestamp } from "firebase/firestore";
    import { getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential, } from "firebase/auth"
    import { db } from '@/firebase';
    import axios from 'axios';
    import { MD5 } from 'md5-js-tools';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            FooterBody,
            InfiniteLoading,
            VuePincodeInput,
        },

        data(){
            return{

                loadingText:"",
                errorText: "",
                successText: "",

                toastMessage: "",

                fullName: "",
                email: "",
                userName: "",

                refCut: "",
                refEmail: "",

                refLink: "",
                refBalance: "",
                refBalanceD: "0.00",
                totalRefs: "",

                withdrawAmount: "",
                serviceCharge: 300,
                bankName: "Select bank",
                bankImage: "https://nigerianbanks.xyz/logo/moniepoint-mfb-ng.png",
                accountName: "",
                accountNumber: "",
                bankList:[],

                payoutAmount: "",
                password: "",
                pin: "",
                verifyPin: "",
                pinExpiry: "",

                lastDocSnapshot: null,
                lastDocSnapshot2: null,
                lastDocSnapshot3: null,

                refList: [],
                depositList: [],
                withdrawList: [],

                coinAddress: "",
                coinName: "Select crypto",
                coinSymbol: "",
                coinImage: "https://www.baesnap.com/images/btc.svg",
                coinCurrency: "",
                
                coinList: [

                    {
                        id: 0,
                        name: "Bitcoin",
                        symbol: "BTC",
                        network: "Bitcoin Network",
                        image: "https://www.baesnap.com/images/btc.svg",
                        currency: "btc",

                    },

                    {
                        id: 1,
                        name: "Ethereum",
                        symbol: "ETH",
                        network: "Ethereum Network",
                        image: "https://www.baesnap.com/images/eth.svg",
                        currency: "eth",

                    },

                    {
                        id: 2,
                        name: "Tether (ERC20)",
                        symbol: "USDT",
                        network: "Ethereum Network",
                        image: "https://www.baesnap.com/images/usdt_eth.svg",
                        currency: "usdterc20",

                    },

                    {
                        id: 3,
                        name: "USDC (ERC20)",
                        symbol: "USDC",
                        network: "Ethereum Network",
                        image: "https://www.baesnap.com/images/usdc.svg",
                        currency: "usdc",

                    },

                    {
                        id: 4,
                        name: "Solana",
                        symbol: "SOL",
                        network: "Solana Network",
                        image: "https://www.baesnap.com/images/sol.svg",
                        currency: "sol",

                    },

                ],

                type: "",
            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Referrals';

            
            document.getElementById("moreN").classList.add("active");
            document.getElementById("moreN2").classList.add("active");

            this.getBanks();
            this.getRefCut();
            this.getUserInfo();

        },

        methods:{

            closeE() {
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS() {
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            async getRefCut(){
                const userRef = doc(db, "AdminInfo", "info");
                const userSnap = await getDoc(userRef);
                let rc = userSnap.data().refCut;
                this.refCut = Number(rc);

            },

            coinSelect(coin){
                this.coinName = coin.name;
                this.coinImage = coin.image;
                this.coinSymbol = coin.symbol;
                this.coinCurrency = coin.currency;
                
            },

            showToast(){
                $(".toast").each(function () {
                    let eachItem = $(this), eachItemId = eachItem.data("id");

                    if (eachItemId) {
                        new bootstrap.Toast($(this)).show();
                    }
                });
            },

            refInvite(){

                let refCount = Number(sessionStorage.getItem("refCount"))

                if(refCount > 10){

                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Maximum quota exceeded...";
                    return;

                }

                axios.post('https://api.baesnap.com/v1/ref-mail', {
                    fullName: sessionStorage.getItem("fullName"),
                    toEmail: this.refEmail,
                    refLink: this.refLink
                })
                .then(function (response) {
                    console.log(response);
                    
                })

                this.toastMessage = "Email sent successfully";
                this.showToast();
                refCount++;
                sessionStorage.setItem("refCount", String(refCount));

            },

            async getUserInfo(){
                
                this.loadingText = "Getting user info...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if(userSnap.exists()){

                    this.refLink = "https://app.baesnap.com/sign-up?ref="+userSnap.data().refCode;
                    this.totalRefs = userSnap.data().totalRefs;
                    this.refBalance = userSnap.data().refBalance;
                    this.fullName = userSnap.data().name;
                    this.userName = userSnap.data().displayId;
                    this.email = userSnap.data().email;

                    if(this.refBalance == 0){
                        this.refBalanceD = "0.00";
                    }
                    else{
                        this.refBalanceD = Number(this.refBalance).toLocaleString("en-US");
                    }
                    

                }
                else{
                    this.$router.push({name: 'sign-in'});
                }

                this.$refs.loadingModal.classList.remove("bg-active");
            },

            copyRef(){
                this.toastMessage = "Link copied successfully!"
                let link = this.refLink
                navigator.clipboard.writeText(link);
                this.showToast(); 

            },

            async getBanks() {

                try {
                    const response = await axios.get("https://nigerianbanks.xyz");
                    this.bankList = response.data;
                }
                catch (error) {
                    console.error(error);
                }

            },

            coinOpen(){
                $('#coinModal').modal('show');
            },

            coinClose(){
                $('#coinModal').modal('hide');
            },

            bankOpen(){
                $('#bankModal').modal('show');
            },

            bankClose(){
                $('#bankModal').modal('hide');
            },

            bankSelect(bank){
                this.bankName = bank.name;
                this.bankImage = bank.logo;
            },

            withdrawClick() {
                this.withdrawAmount = this.refBalance;

                if (this.withdrawAmount < 10000) {
                    this.errorText = "Minimum amount for withdrawal is ₦10,000. You have only earned ₦"+this.refBalanceD;
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                if (this.withdrawAmount >= 10000) {
                    this.serviceCharge = this.withdrawAmount * 0.03;
                }
                else {
                    this.serviceCharge = 300;
                }

                if (this.serviceCharge > 4500) {
                    this.serviceCharge = 4500;
                }

                $('#withdraw').modal('show');
            },

            async withdraw() {

                this.loadingText = "Creating withdrawal request...";
                this.$refs.loadingModal.classList.add("bg-active");

                this.type = "bank";

                if (this.bankName == "Select bank") {
                    this.errorText = "Please select your bank";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }


                if (this.withdrawAmount < 10000) {
                    this.errorText = "Minimum amount for withdrawal is ₦10,000";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                if (this.refBalance < this.withdrawAmount) {
                    this.errorText = "Insufficient earnings...";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                this.payoutAmount = this.withdrawAmount - this.serviceCharge;

                //get verify pin
                this.verifyPin = String(Math.floor(Math.random() * 90000) + 10000);
                //get pin expiry
                this.pinExpiry = (new Date().getTime() / (1000 * 60)) + 30;

                axios.post('https://api.baesnap.com/v1/withdraw-mail', {
                    toName: this.fullName,
                    toEmail: this.email,
                    pin: this.verifyPin
                })
                    .then(function (response) {
                        //console.log(response);
                    })

                this.$refs.loadingModal.classList.remove("bg-active");
                $('#password').modal('show');

            },

            withdraw2() {

                this.loadingText = "Submitting withdrawal request...";
                this.$refs.loadingModal.classList.add("bg-active");

                //check expiry
                if(Number(new Date().getTime() / (1000 * 60)) > this.pinExpiry){
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "The pin has expired. Click resend to generate a new pin";  
                    return;
                }

                if (this.pin != this.verifyPin) {
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Invalid pin";
                    return;
                }

                let passwordHash = MD5.generate(String(this.password));

                const auth = getAuth();

                const user = auth.currentUser;
                const credential = EmailAuthProvider.credential(
                    this.email, passwordHash);

                reauthenticateWithCredential(user, credential)
                    .then((result) => {
                        //password correct
                        if(this.type == "bank"){
                            this.uploadBankWithdraw();
                        }
                        else{
                            this.uploadCryptoWithdraw();
                        }
                    })
                    .catch((error) => {
                        this.errorText = "Invalid password...";
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        return;

                    });

            },

            async cryptoWithdraw(){

                this.loadingText = "Creating withdrawal request...";
                this.$refs.loadingModal.classList.add("bg-active");

                this.type = "crypto";

                if (this.coinName == "Select crypto") {
                    this.errorText = "Please select crypto";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }


                if (this.withdrawAmount < 10000) {
                    this.errorText = "Minimum amount for withdrawal is ₦10,000";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                if (this.refBalance < this.withdrawAmount) {
                    this.errorText = "Insufficient earnings...";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }

                this.payoutAmount = this.withdrawAmount - this.serviceCharge;

                //get verify pin
                this.verifyPin = String(Math.floor(Math.random() * 90000) + 10000);
                //get pin expiry
                this.pinExpiry = (new Date().getTime() / (1000 * 60)) + 30;

                axios.post('https://api.baesnap.com/v1/withdraw-mail', {
                    toName: this.fullName,
                    toEmail: this.email,
                    pin: this.verifyPin
                })
                    .then(function (response) {
                        //console.log(response);
                    })

                this.$refs.loadingModal.classList.remove("bg-active");
                $('#password').modal('show');

            },

            async uploadBankWithdraw() {

                let refBalance, newRefBalance;
                const auth = getAuth();

                //update balance
                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    refBalance = userSnap.data().refBalance;
                }

                newRefBalance = refBalance - this.withdrawAmount;

                await updateDoc(userRef, {
                    refBalance: newRefBalance,
                });

                let mSecs = new Date().getTime() / 1000;
                let transSecs = 10000000000 / mSecs

                await addDoc(collection(db, "RefTrans"), {
                    idD: "BW" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Withdraw",
                    type2: "bank",
                    
                    timeStamp: serverTimestamp(),
                    timeStampN: transSecs,
                    status: "pending",

                    payoutAmount: this.payoutAmount,
                    serviceCharge: this.serviceCharge,
                    withdrawAmount: this.withdrawAmount,

                    bankName: this.bankName,
                    accountName: this.accountName,
                    accountNumber: this.accountNumber,

                    coinName: "",
                    coinSymbol: "",
                    coinAddress: "",

                    userId: auth.currentUser.uid,
                    fullName: this.fullName,
                    username: this.userName,
                    profilePic: this.bankImage,
                    email: this.email,

                });

                //notify admin
                axios.post('https://api.baesnap.com/v1/admin-withdraw-mail', {
                    toName: this.fullName + " - Referral",
                    toEmail: this.email,
                    toUsername: this.userName,
                    bankName: this.bankName,
                    accountNumber: this.accountNumber,
                })
                    .then(function (response) {

                    })

                this.successText = "Your withdrawal request is now pending and will be completed as soon as possible.";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");

            },

            async uploadCryptoWithdraw() {

                let refBalance, newRefBalance;
                const auth = getAuth();

                //update balance
                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    refBalance = userSnap.data().refBalance;
                }

                newRefBalance = refBalance - this.withdrawAmount;

                await updateDoc(userRef, {
                    refBalance: newRefBalance,
                });

                let mSecs = new Date().getTime() / 1000;
                let transSecs = 10000000000 / mSecs

                await addDoc(collection(db, "RefTrans"), {
                    idD: "BW" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Withdraw",
                    type2: "crypto",
                    
                    timeStamp: serverTimestamp(),
                    timeStampN: transSecs,
                    status: "pending",

                    payoutAmount: this.payoutAmount,
                    serviceCharge: this.serviceCharge,
                    withdrawAmount: this.withdrawAmount,

                    bankName: this.coinSymbol,
                    accountName: this.coinName,
                    accountNumber: this.coinAddress,

                    coinName: this.coinName,
                    coinSymbol: this.coinSymbol,
                    coinAddress: this.coinAddress,

                    userId: auth.currentUser.uid,
                    fullName: this.fullName,
                    username: this.userName,
                    profilePic: this.coinImage,
                    email: this.email,

                });

                //notify admin
                axios.post('https://api.baesnap.com/v1/admin-withdraw-mail', {
                    toName: this.fullName + " - Referral",
                    toEmail: this.email,
                    toUsername: this.userName,
                    bankName: this.coinName,
                    accountNumber: this.coinAddress,
                })
                    .then(function (response) {

                    })

                this.successText = "Your withdrawal request is now pending and will be completed as soon as possible.";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");

            },

            profileClick(userId, userName) {

                const auth = getAuth();

                if (auth.currentUser.uid == userId) {
                    this.$router.push({ name: 'profile' });
                    return;
                }

                sessionStorage.setItem("otherId", userId);
                this.$router.push({ name: 'other-profile', params: { id: userName } });
                return;

            },

            async getRefUsers(){

                let res = [];

                const auth = getAuth();

                const q = query(collection(db, "Referrals"), where("ownerId", "==", auth.currentUser.uid), orderBy("dateJoinedN"), limit(10), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                if (res.length > 0) {

                    querySnapshot.forEach(async (doc) => {

                        let status = "expired";
                        
                        let a1 = Number(doc.data().dateJoined.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().dateJoined.seconds) * 1000));

                        //check ref endDate
                        let dateJoinedMili = Number(doc.data().dateJoined.seconds) * 1000;
                        let todayMili = Timestamp.now().seconds * 1000;

                        let refDays = Math.round((todayMili - dateJoinedMili) / (1000 * 60 * 60 * 24));

                        if(Number(refDays) < 365){
                            status = "active"
                        }

                        let result = {

                            id: doc.id,
                            
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().userName,
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            sexuality: doc.data().sexuality,
                            userType: doc.data().userType,
                            dateFull: a2.slice(0, -45),
                            refBalance: doc.data().refBalance,
                            refBalanceD: Number(doc.data().refBalance).toLocaleString("en-US"),
                            status: status
                            

                        }

                        this.refList.push(result);

                        let mIndex = this.refList.length - 1;
                        await this.getFullName(doc.id, doc.data().userId, mIndex);

                    })


                }


                return res.length;

            },

            async getRefDeposit(){

                let res = [];

                const auth = getAuth();

                const q = query(collection(db, "RefTrans"), where("ownerId", "==", auth.currentUser.uid), where("type", "==", "Deposit"), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot2 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot2 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if (res.length > 0) {

                    querySnapshot.forEach(async (doc) => {

                        
                        let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                        let result = {

                            id: doc.id,
                            
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().userName,
                            profilePic: doc.data().profilePic,
                            email: doc.data().email,
                            sexuality: doc.data().sexuality,
                            userType: doc.data().userType,
                            dateFull: a2.slice(0, -45),
                            
                            refAmount: doc.data().refAmount,
                            refAmountD: Number(doc.data().refAmount).toLocaleString("en-US"),
                            status: doc.data().status
                            

                        }

                        this.depositList.push(result);

                        //let mIndex = this.refList.length - 1;
                        //await this.getFullName(doc.id, doc.data().userId, mIndex);

                    })


                }


                return res.length;

            },

            async getWithdrawal(){

                let res = [];

                const auth = getAuth();

                const q = query(collection(db, "RefTrans"), where("userId", "==", auth.currentUser.uid), where("type", "==", "Withdraw"), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot3 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot3 = querySnapshot.docs[querySnapshot.docs.length - 1];

                if (res.length > 0) {

                    querySnapshot.forEach(async (doc) => {

                        
                        let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                        let result = {

                                id: doc.id,
                                type: doc.data().type,
                                type2: doc.data().type2,
                                
                                userId: doc.data().userId,
                                fullName: doc.data().fullName,
                                userName: doc.data().username,
                                profilePic: doc.data().profilePic,
                                email: doc.data().email,
                                userType: doc.data().userType,
                                dateFull: a2.slice(0, -45),

                                accountName: doc.data().accountName,
                                bankName: doc.data().bankName,
                                accountNumber: doc.data().accountNumber,
                                serviceCharge: doc.data().serviceCharge,
                                
                                payoutAmount: doc.data().payoutAmount,
                                payoutAmountD: Number(doc.data().payoutAmount).toLocaleString("en-US"),
                                serviceChargeD: Number(doc.data().serviceCharge).toLocaleString("en-US"),

                                status: doc.data().status
                                
                        }

                        this.withdrawList.push(result);

                        //let mIndex = this.refList.length - 1;
                        //await this.getFullName(doc.id, doc.data().userId, mIndex);

                    })


                }


                return res.length;

            },

            async handleInfinite($state) {

                const newPostCount = await this.getRefUsers();

                if (newPostCount > 0) {
                    //more posts
                    return $state.loaded();
                }

                if (this.refList.length == 0) {
                    document.getElementById("emptyRef").style.display = "flex";
                    document.getElementById("emptyRef").style.visibility = "visible";

                }

                //no more posts
                document.getElementById("emptyRef2").style.display = "none";

                //no more posts
                return $state.complete();

            },

            async handleInfinite2($state) {

                const newPostCount = await this.getRefDeposit();

                if (newPostCount > 0) {
                    //more posts
                    return $state.loaded();
                }

                if (this.refList.length == 0) {
                    document.getElementById("emptyDeposit").style.display = "flex";
                    document.getElementById("emptyDeposit").style.visibility = "visible";

                }

                //no more posts
                document.getElementById("emptyDeposit2").style.display = "none";

                //no more posts
                return $state.complete();

            },

            async handleInfinite3($state) {

                const newPostCount = await this.getWithdrawal();

                if (newPostCount > 0) {
                    //more posts
                    return $state.loaded();
                }

                if (this.refList.length == 0) {
                    document.getElementById("emptyWithdraw").style.display = "flex";
                    document.getElementById("emptyWithdraw").style.visibility = "visible";

                }

                //no more posts
                document.getElementById("emptyWithdraw2").style.display = "none";

                //no more posts
                return $state.complete();

            },

            async getFullName(id, userId, mIndex){

                let i = mIndex;

                const auth = getAuth();
                const userRef = doc(db, "Users", userId);
                const userSnap = await getDoc(userRef);

                if (this.refList[i].id == id){

                    this.refList[i].fullName = userSnap.data().name;
                    this.refList[i].userName = userSnap.data().displayId;
                    this.refList[i].profilePic = userSnap.data().profilePic;
                    this.refList[i].email = userSnap.data().email;
                    this.refList[i].sexuality = userSnap.data().sexuality;
                    this.refList[i].userType = userSnap.data().type;

                }

            }

        }

    }

</script>